export const PARSING_JD = "parsing_JD";
export const PARSING_JD_SUCCESSFUL = "parsing_JD_successfull";
export const PARSING_JD_FAILED = "parsing_JD_failed";
export const ADD_JOB = "add_job";
export const ADD_JOB_SUCCESSFUL = "add_job_successfully";
export const ADD_JOB_FAILED = "add_job_failed";
export const GET_JOB_DATA = "get_job_data";
export const GET_JOB_DATA_SUCCESSFUL = "get_job_data_successfull";
export const GET_JOB_DATA_FAILED = "get_job_data_failed";
export const UPDATE_JOB = "update_job";
export const UPDATE_JOB_SUCCESSFUL = "update_job_successfull";
export const UPDATE_JOB_FAILED = "update_job_failed";
export const GET_QUALIFICATION_FAILED = "qualification_falied";
export const GET_QUALIFICATION_SUCCESSFUL = "qualification_successfull";
export const GET_QUALIFICATION = "get_qualification";
//iplocation
export const JOB_GET_IP_LOCATION_SUCCESSFULL =
  "JOB_GET_IP_LOCATION_SUCCESSFULL";
export const JOB_GET_IP_LOCATION = "JOB_GET_IP_LOCATION";
export const JOB_GET_IP_LOCATION_FAILED = "JOB_GET_IP_LOCATION_FAILED";
//get countries
export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILED = "GET_COUNTRIES_FAILED";
//get state
export const GET_STATE = "GET_STATE";
export const GET_STATE_SUCCESS = "GET_STATE_SUCCESS";
export const GET_STATE_FAILED = "GET_STATE_FAILED";
//get organisation detail
export const GET_ORGANIZATION_DETAIL_JOB = "GET_ORGANIZATION_DETAIL_JOB";
export const GET_ORGANIZATION_DETAIL_SUCCESS =
  "GET_ORGANIZATION_DETAIL_SUCCESS";
export const GET_ORGANIZATION_DETAIL_FAILED = "GET_ORGANIZATION_DETAIL_FAILED";
//taxonomy
export const GET_TAXONOMY_JOBPROFILE = "GET_JOBPROFILE";
export const GET_TAXONOMY_JOBPROFILE_SUCCESS = "GET_JOBPROFILE_SUCCESS";
export const GET_TAXONOMY_JOBPROFILE_FAILED = "GET_JOBPROFILE_FAILED";

//job description
export const GET_TAXONOMY_JOBDESCRIPTION = "GET_JOBDESCRIPTION";
export const GET_TAXONOMY_JOBDESCRIPTION_SUCCESS = "GET_JOBDESCRIPTION_SUCCESS";
export const GET_TAXONOMY_JOBDESCRIPTION_FAILED = "GET_JOBDESCRIPTION_FAILED";
//job skill
export const GET_TAXONOMY_JOBSKILL = "GET_TAXONOMY_JOBSKILL";
export const GET_TAXONOMY_JOBSKILL_SUCCESS = "GET_TAXONOMY_JOBSKILL_SUCCESS";
export const GET_TAXONOMY_JOBSKILL_FAILED = "GET_TAXONOMY_JOBSKILL_FAILED";

//get organization list

export const RECRUITER_ORGANIZATION_DETAIL_GET_LIST =
  "RECRUITER_ORGANIZATION_DETAIL_GET_LIST";
export const RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL =
  "RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL";
export const RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED =
  "RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED";
//bulk import suggestion
export const BULK_IMPORT_SUGGESTION = "BULK_IMPORT_SUGGESTION";
export const BULK_IMPORT_SUGGESTION_SUCCESS = "BULK_IMPORT_SUGGESTION_SUCCESS";
export const BULK_IMPORT_SUGGESTION_ERROR = "BULK_IMPORT_SUGGESTION_ERROR";

//NEW LOCATION
export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_LOCATION_SUCCESSFUL = "ADD_LOCATION_SUCCESSFUL";
export const ADD_LOCATION_FAILED = "ADD_LOCATION_FAILED";

//Job Industres
export const GET_JOB_INDUSTRIES = "GET_JOB_INDUSTRIES";
export const GET_JOB_INDUSTRIES_SUCCESS = "GET_JOB_INDUSTRIES_SUCCESS";
export const GET_JOB_INDUSTRIES_FAILED = "GET_JOB_INDUSTRIES_FAILED";

export const GET_JOB_DEGREES = "GET_JOB_DEGREES";
export const GET_JOB_DEGREES_SUCCESS = "GET_JOB_DEGREES_SUCCESS";
export const GET_JOB_DEGREES_FAILED = "GET_JOB_DEGREES_FAILED";
